import React from "react";
import Subscriber from "../../../subscriber.class";
import Storage from "../../../services/storage.service";
import Events from "../../../services/events.service";
import {vipBundleCommitmentById} from "../../../services/vip.bundle.service"
import Helpers from "../../../services/helpers";
import PlansService from "../../../services/plans.service";
import Flow from "../../../services/flow.service";
import Specs from "../../Plans/Specs.component";
import Numbers from "../../../services/number.service";
import "../../../assets/css/bundle-plan-style.scss";
import Translations from "../../../services/translation";

export default class SummaryPlan extends Subscriber {
  state = {
    saved_plan: null,
    can_go_to_plan: false,
  };

  goToPlan = () => {
    Storage.clear('skip_device_addon');
    Storage.clear("summary_modal");
    Flow.goToStepBase("plan");
  };

  componentDidMount() {
    PlansService.fetchSavedPlans();
    let flags = Storage.get("flow_status_flags");
    if (flags && flags.is_plan_selected && !Storage.get("saved_plan")) {
      PlansService.getSavedPlans()
        .then((res) => {})
        .catch((error) => {});
    }

    this.subscriptions.push(
      Storage.get_obsrv("selectedProduct").subscribe((product) => {
        if (product) {
          let vip_type = Numbers.getProductVanity();
          this.setState({
            numbertype: vip_type,
          });
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("saved_plan").subscribe((data) => {
        this.setState({
          saved_plan: data,
        },this.props.update_plan && this.props.update_plan());
      })
    );

    this.subscriptions.push(
      Flow.get_route().subscribe((data) => {
        this.setState({
          can_go_to_plan:
            data !== Flow.getStepBaseOf("plan") &&
            Flow.isRouteAllowed(Flow.getStepBaseOf("plan")),
        });
      })
    );
  }

	componentWillUnmount() {
    if (this.subscriptions) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }

  render() {
    let vip_class = "";
    let type = Numbers.getProductVanity();
    if (type) {
      vip_class = "vmo-" + type.toLowerCase()
      vip_class = vip_class.replace("+", "");
    }

    let vip_title = "";
    let strings = Translations["keys"][Translations.activeLang];
    let saved_plan = this.state.saved_plan;
    let plan_title = strings["NEW_PLAN_DETAILS_YOUR_PLAN"];

    let isVipNumber = false;
    let has_unlimited_data_plan;
    // let isBundlePlan = false;
    let commitment;
    if (saved_plan) {
      // isBundlePlan = Numbers.isBundlePlan(saved_plan);
      let commitment_key = vipBundleCommitmentById(saved_plan?.VanityLevel);
      commitment = commitment_key? strings[commitment_key]:''
      isVipNumber = Helpers.isVipNumber(saved_plan.VanityLevel);
      let data_subplan_ID = Object.keys(saved_plan['vmo_subplans']).find(item => {
        return saved_plan['vmo_subplans'][item]['Type'] === 'DATA'});
      if (data_subplan_ID) {
        has_unlimited_data_plan = saved_plan['vmo_subplans'][data_subplan_ID]['Value'] === -1? true : false;
      }
    }

    if (this.state.numbertype) {
      let key = this.state.numbertype + "-TEXT";
      vip_title = strings[key] ? strings[key] : this.state.numbertype;
      vip_title = <span className="vmo-vip-color">{vip_title}</span>;
      plan_title = Helpers.getSplitText(plan_title, "%VIP%", vip_title);
    } else {
      plan_title = Helpers.getSplitText(plan_title, "%VIP%", "");
    }

    if (saved_plan) {
      if (saved_plan["vmo_subplans"]) {
        return (
          <div className="vmo-summary-section">
            <div className={"vmo-summary-box-wrapper " + vip_class}>
              <div className="vmo-summary-box">
                
                {this.props.show_vip && isVipNumber?(
                <div className="vip-plan-top-border-style">
                  <div className={`vip-plan-top-border-style-text ${vip_class}`}>
                    {commitment}
                  </div>
                </div>):''}

                <div className="vmo-summary-section-header">
                  <h3> {plan_title} </h3>
                  {this.state.can_go_to_plan && !isVipNumber ? (
                    <div
                      className="vmo-summary-edit"
                      onClick={() => {
                        this.goToPlan();
                        Events.when_user_clicks_on_summary_edit_plan();
                      }}
                    />
                  ) : (
                    ""
                  )}
                  {/* {!isVipNumber && userHasDevicePlan() ?
                    <div
                      className="vmo-summary-edit"
                      onClick={() => {
                        Flow.goTo('/choose-your-iphone');
                        Events.when_user_clicks_on_summary_edit_plan();
                      }}
                    /> : ''
                  } */}
                </div>
                <div className="vmo-plan-specs">
                  <Specs plan={saved_plan} summary={true} show_device_specs={false} disableDeviceEdit={!this.state.can_go_to_plan || this.props.disableDeviceEdit} />
                </div>
              </div>
              {this.props.show_unlimited_data_notice && has_unlimited_data_plan ? 
              <div className="vmo-summary-suffix vmo-summary-notice">
                <div className="vmo-summary-suffix-inner">
                  <div className="vmo-summary-suffix-vertical">
                    <div className="vmo-summary-suffix-body">{strings['SUMMARY_PLAN_UNLIMITED_DATA_NOTICE']}</div>
                  </div>
                </div>
              </div> : '' }
            </div>
          </div>
        );
      }
    }

    return "";
  }
}
